var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"p-1",attrs:{"no-body":""}},[_c('PartEditTabLog',{attrs:{"part-id":_vm.$router.currentRoute.params.parteId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }